import React, { createContext } from 'react';
import { getMessagesConfigV3 } from '@homeexchange/conversations';
import { usePromise } from '@homeexchange/shared';
export var MessageLinkContext = createContext({
    whiteListConfig: {
        allowEmailList: [],
        allowLinkList: []
    }
});
export var MessageLinkProvider = function (_a) {
    var children = _a.children;
    var data = usePromise({
        enabled: true,
        initialData: {
            allowEmailList: [],
            allowLinkList: []
        },
        promiseFn: getMessagesConfigV3
    }).data;
    return (React.createElement(MessageLinkContext.Provider, { value: { whiteListConfig: data } }, children));
};
